import React, { useState, useEffect } from 'react'
import { Link, Redirect, useParams } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import './body.scss'
import { setNewPasswordAsync } from '../_redux/auth.api'
import { injectIntl } from 'react-intl'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'

const addBodyClass = (className) =>
  document.body.classList.add('removeHeaderFooter')
const removeBodyClass = (className) =>
  document.body.classList.remove('removeHeaderFooter')

function SetNewPassword(props) {
  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass('removeHeaderFooter')

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass('removeHeaderFooter')
    }
  }, [props.className])
  const dispatch = useDispatch()

  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true)
  }
  const [passwordShown_v2, setPasswordShown_v2] = useState(false)
  const togglePasswordVisiblity_v2 = () => {
    setPasswordShown_v2(passwordShown_v2 ? false : true)
  }

  const { intl } = props

  const PasswordSchema = () =>
    Yup.object().shape({
      password: Yup.string()
        .trim()
        .required('Please enter a password')
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
          'Password must Contain at least 6 Characters, One Uppercase, One Lowercase, One Number and one special case Character from the followings: [ @$!%*#?& ]',
        ),
      confirmPassword: Yup.string()
        .trim()
        .test('passwords-match', 'Passwords must match', function (value) {
          return this.parent.password === value
        }),
    })

  const params = useParams()

  const onSetPassword = (values) => {
    dispatch(
      setNewPasswordAsync({
        resetToken: params.resetToken,
        password: values.password,
      }),
    )
  }

  const { user } = useSelector((state) => state.auth, shallowEqual)

  if (!params.resetToken) {
    return <Redirect to="/" />
  }

  return (
    <>
      <Formik
        initialValues={{
          password: user && user.password ? user.password : '',
          confirmPassword: '',
        }}
        validationSchema={PasswordSchema}
        onSubmit={(values) => {
          console.log(values)
          onSetPassword(values)
        }}
      >
        {({ handleSubmit }) => (
          <>
            <div className="d-flex flex-column flex-root stnwpspddng">
              <div className="row  w-100 d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                <div className="col-md-4 text-center">
                  <img
                    alt="Logo"
                    className="max-h-70px mb-60"
                    src={toAbsoluteUrl('/media/logos/auth_logo.png')}
                  />
                  <div className="wt_box mb-5">
                    <div
                      className="login-form login-signin"
                      id="kt_login_signin_form"
                    >
                      <div className="text-center mb-10 mb-lg-15">
                        <h3 className="fn_s_32 color_blk f-w-500 mt-3">
                          Set New Password
                        </h3>
                        <p className="opacity60 fn_s_16 color_blk f-w-400">
                          Please never share with anyone for safe use.
                        </p>
                      </div>

                      <Form className="form def_form text-left">
                        <div className="form-group">
                          <label className="form-label">New Password</label>
                          <div className="frpsswrd">
                            <Field
                              placeholder="Password"
                              type={passwordShown ? 'text' : 'password'}
                              className="form-control"
                              name="password"
                            />
                            <i
                              onClick={togglePasswordVisiblity}
                              className="far fa-eye-slash"
                            ></i>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label">Confirm Password</label>
                          <div className="frpsswrd">
                            <Field
                              placeholder="Password"
                              type={passwordShown_v2 ? 'text' : 'password'}
                              className="form-control"
                              name="confirmPassword"
                            />
                            <i
                              onClick={togglePasswordVisiblity_v2}
                              className="far fa-eye-slash"
                            ></i>
                          </div>
                        </div>
                        <div className="form-group mb-0 mt-0">
                          <div className="row">
                            <div className="col-md-12 text-center mb-0">
                              <button
                                id="kt_login_signin_submit"
                                type="submit"
                                className="btn btn-def defwtarw"
                                onClick={() => handleSubmit()}
                              >
                                <span>Submit</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                  <div className="text-center mt-15">
                    <p className="opacity60 fn_s_14 color_blk f-w-400">
                      If you don't want to set new password
                    </p>
                    <Link
                      to="/login"
                      className="bckbtn fn_s_14 color_blk f-w-500 opacity50 uppercase"
                    >
                      Back to Login
                    </Link>
                  </div>
                </div>
                <div className="col-md-12 text-center"></div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  )
}
export default injectIntl(SetNewPassword)
